import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactForm from "@/components/ContactForm";
import CTABanner from "@/components/CTABanner";
import { Mail, Users, Trophy, Wallet } from "lucide-react";
import { PageBreadcrumb, RelatedLinks } from "@/components/SEOBlocks";
import PageHero from "@/components/PageHero";

export default function ContactFullPage() {
  const { t } = useTranslation();
  const contacts = [
    { Icon: Users,  label: t("contactPage.cards.generalSupport", "General support"),   email: "support@ofinancial.markets" },
    { Icon: Trophy, label: t("contactPage.cards.partners",      "Partners"),           email: "partners@ofinancial.markets" },
    { Icon: Mail,   label: t("contactPage.cards.pressMedia",    "Press & media"),      email: "press@ofinancial.markets" },
    { Icon: Wallet, label: t("contactPage.cards.refundsBilling", "Refunds & billing"), email: "refunds@ofinancial.markets" },
  ];
  const CONTACT_RELATED = [
    { to: "/faq",         label: "FAQ",                                                       tagline: t("contactPage.related.faq",     "Common client questions") },
    { to: "/about",       label: t("contactPage.related.aboutLabel", "About OFinancial Markets"), tagline: t("contactPage.related.about",   "Who we are") },
    { to: "/partner",     label: t("common.platforms", "Partners"),                           tagline: t("contactPage.related.partner", "IB & affiliate programs") },
    { to: "/legal/terms", label: t("contactPage.related.termsLabel", "Terms"),                tagline: t("contactPage.related.terms",   "Legal documents") },
  ];
  return (
    <div data-testid="page-contact-full" className="relative overflow-x-hidden">
      <Navbar />
      <PageHero
        breadcrumb={[{ label: t("contactPage.breadcrumb", "Contact") }]}
        pill={{ Icon: Mail, text: t("contactPage.pill", "Contact") }}
        title={t("contactPage.titlePart1", "Talk to")}
        accent={t("contactPage.titleAccent", "OFinancial Markets")}
        subline={t("contactPage.subline", "We respond within 4 business hours. Pick the right inbox below, or send a message via the contact form.")}
        primary={{ label: t("common.browseFaq", "Browse FAQ"),  to: "/faq" }}
        secondary={{ label: t("common.aboutUs", "About us"), to: "/about" }}
      />
      <main className="pb-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-6 mb-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {contacts.map(({ Icon, label, email }) => (
              <a
                key={email}
                href={`mailto:${email}`}
                data-testid={`contact-card-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="card-beam p-4 flex items-center gap-3 hover:bg-[color:var(--surface-2)] transition-colors"
                style={{ border: "1px solid color-mix(in srgb, var(--brand) 14%, transparent)" }}
              >
                <span className="w-10 h-10 rounded-lg grid place-items-center shrink-0"
                  style={{
                    background: "color-mix(in srgb, var(--brand) 10%, transparent)",
                    border: "1px solid color-mix(in srgb, var(--brand) 28%, transparent)",
                  }}>
                  <Icon size={16} className="text-brand" />
                </span>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-[color:var(--text-1)]">{label}</div>
                  <div className="text-[12px] text-[color:var(--text-3)] truncate">{email}</div>
                </div>
              </a>
            ))}
          </div>
        </div>

        <ContactForm />

        <RelatedLinks items={CONTACT_RELATED} />
      </main>
      <CTABanner />
      <Footer />
    </div>
  );
}
